import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Globals } from 'src/app/shared/globals/globals';
import { EnquiryHeaderItem, OrderExtraCost } from 'src/app/shared/models/data/enquiry.model';
import { CalculatedCols, CustomIcoCol } from 'src/app/shared/teiasoft-bucket/teiasoft-grid/teiasoft-grid.component';
import { SelectOption } from 'src/app/shared/teiasoft-bucket/teiasoft-select/teiasoft-select.component';

@Component({
  selector: 'app-modal-add-order-extra-costs',
  standalone: false,
  templateUrl: './modal-add-order-extra-costs.component.html',
  styleUrl: './modal-add-order-extra-costs.component.scss'
})
export class ModalAddOrderExtraCostsComponent implements OnInit {

  @Output() onSave = new EventEmitter<OrderExtraCost>();
  @Output() onCancel = new EventEmitter<void>();

  @Input() amount = 0;
  @Input() enquiryNo!: string;
  @Input() unitSystem!: string;
  @Input() currency: string = '';
  @Input() items!: EnquiryHeaderItem[];
  @Input() selectedItemsNo: any[] = new Array();

  @Input() columnsToShowItem!: string[];
  @Input() customIcoCols!: CustomIcoCol[];
  @Input() calculatedCols!: CalculatedCols[];

  uomOptionsList: SelectOption[] = new Array();
  uom: string = '';
  selectedItems: any[] = new Array();


  @ViewChild('viewCost', { static: true }) viewCostTemplate!: TemplateRef<any>;
  @ViewChild('viewExtraCosts', { static: true }) viewExtraCostsTemplate!: TemplateRef<any>;
  @ViewChild('viewDeliveryDates', { static: true }) viewDeliveryDates!: TemplateRef<any>;

  customRenderers = {
    initialPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'initialPrice' }
      };
    },
    previousRevisionPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'previousRevisionPrice' }
      };
    },
    finalPricePerLength: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'finalPricePerLength', uomColumn: 'finalPricePerLengthUom' }
      };
    },
    deliveryDate: (row: any) => {
      return {
        template: this.viewDeliveryDates,
        context: { $implicit: row, column: 'delilveryDate' }
      };
    },
    alloySurchargeValue: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'alloySurchargeValue' }
      };
    },
    energySurchargeValue: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'energySurchargeValue' }
      };
    },
    minimumFm: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'minimumFm' }
      };
    },
    recommendedFm: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'recommendedFm' }
      };
    },
    fullCost: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'fullCost' }
      };
    },
    minimumPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'minimumPrice' }
      };
    },
    recommendedPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'recommendedPrice' }
      };
    },
    extraCosts: (row: any) => {
      return {
        template: this.viewExtraCostsTemplate,
        context: { $implicit: row, column: 'extraCosts' }
      };
    },
    actualFm: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'actualFm' }
      };
    },
    finalPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'finalPrice' }
      };
    }
  };

  constructor(public globals: Globals) {
  }

  ngOnInit(): void {
    this.buildUomOptionsList();
    this.uom = this.uomOptionsList[0].value;

    if (this.items) {
      this.items = this.items.sort(
        function (a, b) {
          return Number(a.itemNo!) - Number(b.itemNo!);
        }
      );
    }

    this.selectedItems = this.items.filter(i => this.selectedItemsNo.includes(i.itemNo));
  }

  buildUomOptionsList() {
    this.uomOptionsList = new Array();

    const value = this.currency || this.getCurrencyFromItems();

    let option = new SelectOption();
    option.isDefault = true;
    option.text = value;
    option.value = value;

    this.uomOptionsList.push(option);
  }

  private getCurrencyFromItems(): string {
    const item = this.items?.find(i => (i as any).finalPriceUom || (i as any).finalPricePerLengthUom || (i as any).costsUom);
    const uom = (item as any)?.finalPriceUom || (item as any)?.finalPricePerLengthUom || (item as any)?.costsUom || '';
    return uom.toString().split('/')[0]?.trim() ?? '';
  }

  onSaveClick() {

    this.onSave.emit({
      amount: this.amount,
      uom: this.uom,
      items: this.selectedItemsNo
    });
  }

  onCancelClick() {
    this.onCancel.emit();
  }

  onInputAmount(amount: number) {
    this.amount = amount;
  }

  onRowSelection($event: any[]) {
    this.selectedItemsNo = $event.map(i => i.itemNo);
  }

}
